import React from 'react';
import '../../components/css/popupstyle.css';
import { userService } from '../../_services';
import $ from 'jquery';

class upcomingDate extends React.Component {
    constructor(props) {
        super(props);
        var startdate = new Date();
        var enddate = new Date();
        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
            startDate: startdate,
            currentDate: startdate,
            error: '',
            loader: false,
            mhError: '',
            whError: '',
            userError: '',
            options: [
                //{ date: 'December,2021', value: 'December,2021' },
                //{ date: 'January,2022', value: 'January,2022' },
                { date: 'February,2022', value: 'February,2022' },
                { date: 'March,2022', value: 'March,2022' },
                { date: 'April,2022', value: 'April,2022' },
                { date: 'May,2022', value: 'May,2022' },
                { date: 'June,2022', value: 'June,2022' },
                { date: 'July,2022', value: 'July,2022' },
                { date: 'August,2022', value: 'August,2022' },
                { date: 'September,2022', value: 'September,2022' },
                { date: 'October,2022', value: 'October,2022' },
                { date: 'November,2022', value: 'November,2022' },
                { date: 'December,2022', value: 'December,2022' },
                { date: 'January,2023', value: 'January,2023' },
            ],
            selectValue: [],
            expanded: false,
            defaultOption: 'Select Month[s]',
            binData: [],
            bonusLoader: false,
            settingData: []
        }
        this.whBonus = React.createRef();
        this.userBonus = React.createRef();
        this.bin = React.createRef();
    }
    handleCancel = () => {
        try {
            this.props.closeDatePopup(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
            this.props.openEditProfilePopup(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
        }
        catch (error) { }
    }
    bonusSetting = () => {
        try {
            userService.Wh_Bonus_Setting('_', '_', this.props.whId).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            this.setState({ settingData: apidata });
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Opps!, Something went wrong. Try Again.' });
                    }
                }
            );
        }
        catch (error) {
            this.setState({ error: 'Opps!, Something went wrong. Try Again.' });
        }
    }
    componentDidMount() {
        this.bonusSetting();
        this.getBin();
        let bind = this;
        var checkboxes = document.getElementById("checkboxes");
        $(document).mouseup(function(e) {
            if ($(e.target).closest(".multiselect").length === 0) {
                checkboxes.style.display = "none";
                bind.setState({ expanded: false });
            }
        });
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }
    handleSubmit = () => {
        try {
            this.setState({ loader: true, mhError: '', whError: '', userError: '', error: '' });
            let error_set = 0;
            let monthName = this.state.selectValue.join('-');
            let BIN = this.bin.current.value;
            let whBonus = this.whBonus.current.value;
            let userBonus = this.userBonus.current.value;
            if (userService.Check_Null_Empty(userBonus)) {
                userBonus = "0.00";
            } else {
                if (!userService.checkNumericValue(userBonus)) {
                    error_set += 1;
                    this.setState({ loader: false, userError: 'User bonus must be numeric' });
                }
            }
            let whId = this.props.whId;
            let is_new_month = this.check_selected_month(monthName);
            if (userService.Check_Null_Empty(monthName)) {
                error_set += 1;
                this.setState({ loader: false, mhError: 'Month[year] required' });
            }
            if (userService.Check_Null_Empty(whBonus)) {
                error_set += 1;
                this.setState({ loader: false, whError: 'Wholesaler bonus required' });
            } else {
                if (!userService.checkNumericValue(whBonus)) {
                    error_set += 1;
                    this.setState({ loader: false, whError: 'Wholesaler bonus must be numeric' });
                }
            }
            if (is_new_month == false && !userService.Check_Null_Empty(monthName)) {
                error_set += 1;
                this.setState({ loader: false, error: 'There is already a bonus program with one of these months selected, please try again' });
            }
            if (error_set == 0) {
                this.updateData(whId, monthName, whBonus, userBonus, BIN);
            }
        } catch (error) { }
    }
    check_selected_month(m) {
        var cango = false;
        try {
            var m_list = m.split('-');
            if (this.state.settingData.length > 0) {
                for (var ik = 0; ik < m_list.length; ik++) {
                    var ismonth = this.state.settingData.filter((x) => x.monthname.indexOf(m_list[ik]) !== -1);
                    if (ismonth != null && ismonth.length > 0) {
                        cango = false;
                        break;
                    }
                    else {
                        cango = true;
                    }
                }
            }
            else {
                cango = true;
            }
        } catch (e) {

        }
        return cango;
    }
    updateData = (whId, monthName, whBonus, userBonus, BIN) => {
        try {
            userService.BonusProgram(whId, monthName, whBonus, userBonus, BIN).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].code == "1") {
                                this.setState({ loader: false, error: apidata[0].message });
                                this.bonusSetting();
                                setTimeout(() => {
                                    this.setState({ error: '' });
                                }, 5000)
                            }
                            else {
                                this.setState({ loader: false, error: apidata[0].message });
                                setTimeout(() => {
                                    this.setState({ error: '' });
                                }, 5000)
                            }
                        } else {
                            this.setState({ loader: false, error: 'Error! Please try again.' });
                            setTimeout(() => {
                                this.setState({ error: '' });
                            }, 5000)
                        }
                    }
                    catch (error) {
                        this.setState({ loader: false, error: 'Opps!, Something went wrong. Please try again.' });
                        setTimeout(() => {
                            this.setState({ error: '' });
                        }, 5000)
                    }
                }
            );
        }
        catch (error) {
            this.setState({ loader: false, error: 'Opps!, Something went wrong. Try Again.' });
        }
    }
    handleSelect = (e) => {
        try {
            $(e.target).toggleClass('active');
            let selected = e.target.getAttribute('value');
            let sValue = this.state.selectValue;
            if ($(e.target).hasClass('active')) {
                sValue.push(selected);
            } else {
                sValue = sValue.filter(function(item) {
                    return item !== selected
                })
            }
            if (sValue.length > 1) {
                $(e.target).parents().eq(2).addClass('change-maxwidth');
            } else {
                $(e.target).parents().eq(2).removeClass('change-maxwidth');
            }
            this.setState({ selectValue: sValue });
            e.stopPropagation();
            e.preventDefault();
            return false;
        } catch (error) {
        }
    }
    showCheckboxes = () => {
        try {
            var checkboxes = document.getElementById("checkboxes");
            if (!this.state.expanded) {
                checkboxes.style.display = "block";
                this.setState({ expanded: true });
            } else {
                checkboxes.style.display = "none";
                this.setState({ expanded: false });
            }
        } catch (error) {
        }
    }
    getBin = () => {
        this.setState({ bonusLoader: true });
        try {
            userService.Bind_Tier_List().then(
                apidata => {
                    try {
                        if (apidata[0].binDetail.length > 0) {
                            this.setState({ binData: apidata[0].binDetail, bonusLoader: false });
                        } else {
                            this.setState({ error: 'Opps!, Something went wrong. Try Again.', bonusLoader: false });
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Opps!, Something went wrong. Try Again.', bonusLoader: false });
                    }
                }
            );
        }
        catch (error) {
            this.setState({ error: 'Opps!, Something went wrong. Try Again.', bonusLoader: false });
        }
    }
    render() {
        var distinct_level = [];
        var _month = [];
        var _whComm = '';
        var _userComm = '';
        var _bin = '';
        const { loader, error, mhError, whError, userError, bonusLoader } = this.state;
        if (this.state.settingData != null && this.state.settingData.length > 0) {

            //------------------------
            distinct_level = this.state.settingData.filter((obj, pos, arr) => {
                return arr.map(mapObj => mapObj["levelid"]).indexOf(obj["levelid"]) === pos;
            })
            //------------------------
            _whComm = this.state.settingData[0].whcomm;
            _userComm = this.state.settingData[0].usercomm;
            _bin = this.state.settingData[0].bin;
            for (let i = 0; i < this.state.settingData.length; i++) {
                _month.push(this.state.settingData[i].monthname);
            }
        }
        let disabled = false;
        disabled = this.state.bonusLoader ? true : false;
        return (
            <div className='popup mfp-zoom-in override-content upcomingDate-popup'>
                <div className='popup_inner'>
                    {bonusLoader &&
                        <div className="theme-loader bonus-loader"></div>
                    }
                    <h1>{this.props.titleText}<button onClick={this.handleCancel}>X</button></h1>
                    <div className="wholesaler-section">
                        <form className="add-wh-form">
                            <div className="new-section">
                                <div className="new-column gap-right">
                                    <div className="same-on">
                                        <label>Select Month[Year]</label>
                                        <div class="multiselect">
                                            <div class="selectBox" onClick={this.showCheckboxes}>
                                                <span class="down-arrow"></span>
                                                <select className={this.state.selectValue.length == 0 ? '' : "hide-element"}>
                                                    <option>{this.state.defaultOption}</option>
                                                </select>
                                                <div class="overSelect">
                                                    <div class="selectOver">
                                                        {
                                                            this.state.selectValue.map((item) => {
                                                                return <span>{item}</span>
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="checkboxes">
                                                {
                                                    this.state.options.map((item) => {
                                                        return <label value={item.value} onClick={this.handleSelect}><input type="checkbox" />{item.date}</label>
                                                    })
                                                }
                                            </div>
                                        </div>
                                        {
                                            mhError &&
                                            <div className={'alert alert-danger'}>{mhError}</div>
                                        }
                                    </div>
                                </div>
                                <div className="new-column gap-left">
                                    <div className="same-on">
                                        <label>BIN</label>
                                        <span class="down-arrow"></span>
                                        <select className="form-control" ref={this.bin}>
                                            {
                                                this.state.binData.map((item) => {
                                                    return <option>{item.bin}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="new-section">
                                <div className="new-column gap-right">
                                    <div className="same-on">
                                        <label>Wholesaler bonus commission</label>
                                        <input type="text" ref={this.whBonus} className="form-control wh-bonus" />
                                        {
                                            whError &&
                                            <div className={'alert alert-danger'}>{whError}</div>
                                        }
                                    </div>
                                </div>
                                <div className="new-column gap-left">
                                    <div className="same-on">
                                        <label>User bonus commission</label>
                                        <input type="text" ref={this.userBonus} className="form-control user-bonus" />
                                        {
                                            userError &&
                                            <div className={'alert alert-danger'}>{userError}</div>
                                        }                                        
                                    </div>
                                </div>
                            </div>
                            {
                                this.state.settingData.length > 0 ?
                                    <div>
                                        <h1 className="bonus-heading">Running bonus program</h1>
                                        <div className="bonus-setting">
                                            <div className="first-one">
                                                <label>Month(s)</label>
                                            </div>
                                            <div>
                                                <label>Wh.Comm.</label>
                                            </div>
                                            <div>
                                                <label>User Comm.</label>
                                            </div>
                                            <div>
                                                <label>BIN</label>
                                            </div>
                                        </div>
                                        <div className="bonus-content">
                                            {
                                                distinct_level.map((item, index) => {
                                                    var level_wise_list = this.state.settingData.filter(a => a.levelid == item["levelid"]);
                                                    {
                                                        if (level_wise_list.length > 0) {
                                                            return <div className="bonus-setting last">
                                                                <div className="first-one">
                                                                    {
                                                                        level_wise_list.map((item) => {
                                                                            return <span>{item.monthname}</span>
                                                                        })
                                                                    }
                                                                </div>
                                                                <div>
                                                                    <span>{level_wise_list[0].whcomm}</span>
                                                                </div>
                                                                <div>
                                                                    <span>{level_wise_list[0].usercomm}</span>
                                                                </div>
                                                                <div>
                                                                    <span>{level_wise_list[0].bin}</span>
                                                                </div>
                                                            </div>
                                                        }
                                                    }
                                                })
                                            }
                                        </div>
                                    </div> : null
                            }
                            <div className="same-on">
                                {loader &&
                                    <div className="theme-loader"></div>
                                }
                                <input type="button" disabled={disabled} onClick={this.handleSubmit} className={loader ? 'btn add-wholesaler animated-btn' : 'btn add-wholesaler'} value="Submit" />
                            </div>
                            {error &&
                                <div className={'alert alert-danger'}>{error}</div>
                            }
                        </form>
                    </div>

                </div>
            </div>
        )
    }
}
export default upcomingDate;